import ChannelList from "./channels/ChannelList";
import ChannelCreate from "./channels/ChannelCreate";
import IntegrationList from "./integration/IntegrationList";
import IntegrationCreate from "./integration/IntegrationCreate";
import MigrationList from "./migration/MigrationList";

const routes = [
    {
        path: "company/:company/plugin/channels/list",
        component: () => <ChannelList />,
        isSidebar: true,
        isPublic: false,
        permissions: ["view_channels"],
    },
    {
        path: "company/:company/plugin/integrations/list",
        component: () => <IntegrationList />,
        isSidebar: true,
        isPublic: false,
        permissions: ["view_integrations"],
    },
    {
        path: "company/:company/plugin/integrations/create",
        component: () => <IntegrationCreate />,
        isSidebar: true,
        isPublic: false,
        permissions: ["create_integration"],
    },
    {
        path: "company/:company/plugin/migrations/list",
        component: () => <MigrationList />,
        isSidebar: true,
        isPublic: false,
        permissions: ["update_integration"],
    },
    {
        path: "company/:company/channel/create",
        component: () => <ChannelCreate />,
        isSidebar: true,
        isPublic: false,
        permissions: ["create_channel"],
    },
    {
        path: "company/:company/channels/update",
        component: (data) => <ChannelList data={data} />,
        isSidebar: true,
        isPublic: false,
        permissions: ["update_channel"],
    },
];

export default routes;
